import { render, staticRenderFns } from "./FactionSelector.vue?vue&type=template&id=32d16af8&scoped=true&"
import script from "./FactionSelector.vue?vue&type=script&lang=js&"
export * from "./FactionSelector.vue?vue&type=script&lang=js&"
import style0 from "./FactionSelector.vue?vue&type=style&index=0&id=32d16af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d16af8",
  null
  
)

export default component.exports